import { useLocation } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { selectionStore } from 'entities/tour/models'
import { FlightDetails } from 'entities/tour/ui/flight-details'

import { mapRawTourFlightToDisplayFlight } from 'shared/api/tours/flights'

const FlightDetailsPage = observer(() => {
  const selectedFlight = selectionStore.getSelectedFlight()
  const state = useLocation().state as { isViewMode?: boolean }

  return (
    <FlightDetails
      isViewMode={state?.isViewMode}
      selectedFlight={mapRawTourFlightToDisplayFlight(selectedFlight)}
    />
  )
})

export default FlightDetailsPage
